
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormColProps"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormColProps"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"as"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"md"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xl"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  

    module.exports = doc
  
